export default __webpack_public_path__ + "static/media/dev.a6e33e10.png";